import {
  Component,
  computed,
  input,
  TemplateRef,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DisplayLoad } from '@services/shipment.model';
import {
  CheckpointLaneComponent,
  DateStringComponent,
  ShipmentTrackingCheckpoint,
  ShipmentTrackingStatusComponent,
} from '@tiltgroup/web-components';

@Component({
  selector: 'lt-shipment-info',
  templateUrl: './shipment-info.component.html',
  styleUrls: ['./shipment-info.component.scss'],
  // Keeps pre-Angular 22 (Default) change detection, which this component was written for.
  // TODO: migrate to OnPush.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ShipmentTrackingStatusComponent,
    CheckpointLaneComponent,
    DateStringComponent,
  ],
})
export class ShipmentInfoComponent {
  shipment = input<DisplayLoad | null>(null);

  pickedUpCheckpointDetailsTemplate = viewChild<TemplateRef<any>>(
    'pickedUpCheckpointDetails'
  );
  deliveredCheckpointDetailsTemplate = viewChild<TemplateRef<any>>(
    'deliveredCheckpointDetails'
  );

  statusCheckpoints = computed<ShipmentTrackingCheckpoint[]>(() => {
    if (!this.shipment()) return [];
    return this.shipment().statusCheckpoints.map((c) => {
      return {
        ...c,
        templateRef:
          c.status === 'Picked up'
            ? this.pickedUpCheckpointDetailsTemplate()
            : c.status === 'Delivered'
              ? this.deliveredCheckpointDetailsTemplate()
              : undefined,
      };
    });
  });

  dateFormat = 'MM/dd/yyyy';
  timeFormat = 'HH:mm';
}
